import React, { useState } from 'react';
import { ImprestExpenseCustomData, MyTickets, RaisedTickets } from './TicketsTables';
import Dashboardnavbar from '../../layout/Dashboardnavbar';
import usePermission from '../../config/permissions';
import { useLocation } from 'react-router-dom';

const TicketsManagement = () => {
    const { PERMISSION_ROLE, PERMISSION_AUTHORITY, SUPER_ADMIN } = usePermission(); // Use the custom hook
    const role = sessionStorage.getItem('sitemanagement_role')
    const location = useLocation();
    const [toggleState, setToggleState] = useState(location.state?.toggleState || 1); // default to 1

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return 'My Tickets';
            case 2:
                return 'Raised Tickets';
            // case 3:
            //     return 'Custom Expense Excel';
            default:
                return 'My Tickets';
        }
    };


    return (
        <>
            <Dashboardnavbar name={getSelectedTitle()} url="Tickets Managment" />
            {role === "Admin" ?
                <div className="bloc-tabss2  wfm-margin">
                    <button
                        className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                        onClick={() => setToggleState(1)}
                    >
                        My Tickets
                    </button>
                    < button
                        className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                        onClick={() => setToggleState(2)}
                    >
                        Raised Tickets
                    </button>

                </div>
                : null
            }
            <div>
                {toggleState === 1 ? <MyTickets /> : null}
                {toggleState === 2 ? <RaisedTickets /> : null}
            </div>
        </>
    );
};

export default TicketsManagement;